export function ArrowReply1Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15 9a1 1 0 01-1 1h-1.615a8.388 8.388 0 00-8.233 6.786A15.58 15.58 0 0113.043 14H14a1 1 0 011 1v1.963L19.632 12 15 7.037V9zm-2-1V5.769c0-1.362 1.668-2.02 2.597-1.024l5.816 6.231a1.5 1.5 0 010 2.047l-5.816 6.232c-.93.995-2.597.338-2.597-1.023V16a13.58 13.58 0 00-8.979 3.43c-.783.696-2.02.14-2.02-.907v-.138C2 12.65 6.65 8 12.384 8H13z"
      ></path>
    </svg>
  );
}
